var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSigningSymbol = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.58 3.04C1.05 3.5 1.79 3.52 2.29 3.1C2.66 2.78 2.98 2.59 3.16 2.67C3.66 2.87 3.16 3.7 2.86 4.19C2.61 4.61 0 8.08 0 10.5C0 11.78 0.48 12.84 1.34 13.48C2.09 14.04 3.08 14.21 3.98 13.94C5.05 13.63 5.93 12.54 7.04 11.17C8.25 9.68 9.87 7.73 11.12 7.73C12.75 7.73 12.77 8.74 12.88 9.52C9.1 10.16 7.5 13.19 7.5 14.89C7.5 16.59 8.94 17.98 10.71 17.98C12.34 17.98 15 16.65 15.4 11.88H16.61C17.3 11.88 17.86 11.32 17.86 10.63C17.86 9.94 17.3 9.38 16.61 9.38H15.39C15.24 7.73 14.3 5.18 11.36 5.18C9.11 5.18 7.18 7.09 6.42 8.02C5.84 8.75 4.36 10.5 4.13 10.74C3.88 11.04 3.45 11.58 3.02 11.58C2.57 11.58 2.3 10.75 2.66 9.66C3.01 8.57 4.06 6.8 4.51 6.14C5.29 5 5.81 4.22 5.81 2.86C5.81 0.69 4.17 0 3.3 0C2.21 0 1.26 0.63 0.6 1.22C0.0699999 1.7 0.0699999 2.54 0.58 3.04ZM10.74 15.55C10.43 15.55 10 15.29 10 14.83C10 14.23 10.73 12.63 12.87 12.07C12.57 14.76 11.44 15.55 10.74 15.55Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSigningSymbol);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/signing-symbol.077f2fc1cb4331881508cb29771b87cf.svg";